import React, { useImperativeHandle, forwardRef } from 'react';

const DraftField = forwardRef((props, ref) => {
  const { component: Component, editorRef, handleOnChange, ...rest } = props;
  useImperativeHandle(ref, () => {
    return {
      focus: () => {
        editorRef.current.focus();
      },
    };
  });

  return (
    <Component
      {...rest}
      ref={editorRef}
      onChange={handleOnChange}
      stripPastedStyles={true}
    />
  );
});

export default DraftField;
